import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React from "react";
import SwitchCheckbox from "../../../global/content/SwitchCheckbox";
import OWASP from "../../../../util/owasp";

const MantPermissionAreaCargoComponent = ( {title, idEdit, createData, closeSection, idRef, componentes, setComponentes,
                                               areas, cargos, fnBuscar, icon, showCreate, showEdit, changeArea}) => {
    const { handleSubmit, setValue, register, formState: { errors } } = useForm({mode: "onChange"});
    // const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    const onSubmit1 = (form) => {
        let arrElements = [];
        componentes.map(cmp => {
            cmp.permisos.map(perm => {
                if (cmp.componente.enlaceInterno != '#') {
                    let check = document.getElementById(`chk_${cmp.componente.id}_${perm.permisoId}`)
                    console.log(`key: ${cmp.componente.id}_${perm.permisoId}, name: ${cmp.componente.nombre}_${perm.nombre} -> ${check.checked}`);
                    
                    if (check.checked) {    
                        arrElements.push({'permisoId': perm.permisoId, 'componenteId': cmp.componente.id})
                    }
                }
            })
        });
        // console.log('arrElements', arrElements);
        let data = {
            'areaId': form.areaId, 
            'cargoId': form.cargoId, 
            'permisos': arrElements
        }
        createData(data);
    };

    const loadForm = (object) => {
        // setValue('nombre', object.nombre);
        // setValue('descripcion', object.descripcion);
    };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="areaId" className="control-label col-form-label">Área <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("areaId", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    setComponentes(CONFIGURACIONES.INIT.ARRAY);
                                                    setValue("cargoId", "");
                                                    changeArea(e.target.value);
                                                }
                                            })} className="form-control" id="areaId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                                
                                            {
                                                areas.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.areaId && errors.areaId.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="cargoId" className="control-label col-form-label">Cargo <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("cargoId", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    setComponentes(CONFIGURACIONES.INIT.ARRAY);
                                                }
                                            })} className="form-control" id="cargoId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                                
                                            {
                                                cargos.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.cargoId && errors.cargoId.message }</small>           
                                    </div>
                                </div>
                                
                                <div className="col-sm-1 my-auto pt-3">
                                    <button type="button" className="btn btn-sm btn-info" onClick={fnBuscar}>
                                        <i className="mdi mdi-magnify"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <div className="row">
                                {componentes.map((cmp, index) => (
                                    <React.Fragment key={`frag_${cmp.componente.id}__${index}`}>
                                        {cmp.componente.enlaceInterno != '#' && <div className="col-sm-12 col-md-12 pb-3 pt-2 border-bottom">
                                            <h4>{cmp.componente.nombre}</h4>
                                            <div className="row">
                                                {cmp.permisos.map((perm) => (
                                                    <React.Fragment key={`column_${cmp.componente.id}__${perm.permisoId}`}>
                                                        <div className="col-sm-12 col-md-3">
                                                            <SwitchCheckbox label={`Permitir ${perm.permisoNombre}`} name={`chk_${cmp.componente.id}_${perm.permisoId}`} checked={perm.estadoId == 'Y'?true:false} />
                                                        </div>
                                                    </React.Fragment> 
                                                ))}
                                            </div>
                                        </div>}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                       
                    <div className="action-form mt-3 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && showEdit && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantPermissionAreaCargoComponent;